/**
 * Palier d'une grille tarifaire (table TARIFICATION).
 * typPrelev : 'POURCENTAGE' | 'FIXE' | 'MIXTE'
 * borneSup null = palier terminal sans plafond.
 */
export interface TarificationPalier {
    codTarif: string;
    numPalier: number;
    borneInf: number;
    borneSup: number | null;
    typPrelev: 'POURCENTAGE' | 'FIXE' | 'MIXTE';
    taux: number | null;
    mtnFixe: number | null;
    mtnMin: number | null;
    mtnMax: number | null;
    libelleGrille: string;
}

export interface TarificationGrille {
    codTarif: string;
    nbPaliers: number;
    libelleGrille: string;
}

export function normalizePalier(raw: any): TarificationPalier {
    const num = (v: any): number | null => {
        if (v === null || v === undefined || v === '') return null;
        const n = parseFloat(String(v).replace(/\s/g, '').replace(',', '.'));
        return isNaN(n) ? null : n;
    };
    return {
        codTarif: String(raw?.codTarif ?? raw?.CODTARIF ?? '').trim(),
        numPalier: num(raw?.numPalier ?? raw?.NUMPALIER) ?? 0,
        borneInf: num(raw?.borneInf ?? raw?.BORNEINF) ?? 0,
        borneSup: num(raw?.borneSup ?? raw?.BORNESUP),
        typPrelev: (String(raw?.typPrelev ?? raw?.TYPPRELEV ?? 'FIXE').toUpperCase() as TarificationPalier['typPrelev']),
        taux: num(raw?.taux ?? raw?.TAUX),
        mtnFixe: num(raw?.mtnFixe ?? raw?.MTNFIXE),
        mtnMin: num(raw?.mtnMin ?? raw?.MTNMIN),
        mtnMax: num(raw?.mtnMax ?? raw?.MTNMAX),
        libelleGrille: String(raw?.libelleGrille ?? raw?.LIBELLE_GRILLE ?? '')
    };
}
